<template>
    <fieldset class="form-group">
        <legend>
            {{filter.displayName}}
            <span class="unit" v-if="filter.unit"> ({{filter.unit}})</span>
        </legend>
        <div :id="filter.displayName" role="group" tabindex="-1" class="btn-group btn-group-toggle">
            <template v-for="(option, index) in filter.options" :key="option.value + '-' + index">
                <label class="btn btn-secondary" v-bind:class="{'active': isSelected(option.value), 'disabled': $parent.shouldBeDisabled(filter, option) && !isSelected(option.value)}">
                    <input type="checkbox" :name="filter.name" :value="option.value" v-on:change="checkboxchange($event)" v-model="internalModel" :disabled="disabledFn(filter, option) && !isSelected(option.value)">
                    <span class="bullet--container" v-if="filter.convertValueToBullets">
                        <span class="bullet" v-for="bullet in parseInt(option.text)"></span>
                        <span class="sr-only">{{option.text}}</span>
                    </span>
                    <span v-else>{{option.text}}</span>
                </label>
            </template>
        </div>
    </fieldset>
</template>

<script>
import bus from "../utils/eventBus";

    export default {
        name: 'CheckboxButtonGroup',
        props: {
            filter: { type: Object, required: true },
            disabledFn: { type: Function, default: () => (filter, option) => false },
            modelValue: { type: Array, default: () => [] }
        },
        emits: ['update:modelValue'],
        data() {
            return {
            };
        },
        created() {
            if (bus && typeof bus.$on === 'function') {
                bus.$on('resetFilters', () => {
                    this.$emit('update:modelValue', []);
                });
            }
        },
        computed: {
            internalModel: {
                get() {
                    return Array.isArray(this.modelValue) ? this.modelValue : [];
                },
                set(val) {
                    this.$emit('update:modelValue', val);
                }
            }
        },
        methods: {
            checkboxchange(e) {
                this.$emit('update:modelValue', this.internalModel);
            },
            isSelected(value) {
                return this.internalModel && this.internalModel.includes(value);
            }
        }
    }
</script>
